import { type AppTableFeatures } from '@design/components/table';
import { Column } from '@tanstack/react-table';
import { TableAction } from '@terminal/views/screener/results/screener-table-utils';
import { EmptyTableData } from '@terminal/widgets/scenario/utils/scenario-table-utils/scenario-table-utils';

export const useEmptyTableActions = () => {
  const getEnabledKeys = (column: Column<AppTableFeatures, EmptyTableData>) => {
    if (column.id !== 'entity') {
      return [];
    }

    const enabledKeys: TableAction[] = ['ascending', 'descending'];

    if (column.getIsSorted()) {
      enabledKeys.push('clearSort');
    }

    return enabledKeys;
  };

  const handleDropdownAction =
    (column: Column<AppTableFeatures, EmptyTableData>) =>
    (action: TableAction) => {
      if (action === 'ascending') {
        return column.toggleSorting(false);
      }

      if (action === 'descending') {
        return column.toggleSorting(true);
      }

      if (action === 'clearSort') {
        column.clearSorting();
      }
    };

  return {
    getEnabledKeys,
    handleDropdownAction,
  };
};
